import { Component, h, Host, Prop } from '@stencil/core';


@Component({
    tag: 'lilu-feedback',
    styleUrl: 'lilu-feedback.scss',
    shadow: true
})
export class LiluFeedback {
  @Prop() appearance: '' | 'pdp' = '';

  render() {
    return (
      <Host>
        <div class={`feedback ${this.appearance}`}>
          <slot name="title"></slot>
          <slot name="text"></slot>
          <div class="links">
            <slot name="links"></slot>
          </div>
        </div>
      </Host>
    );
  }
}
